import create from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

const useBlendShapeStore = create(
  subscribeWithSelector((set) => ({
    isSynthesizing: false,
    isRecognizing: true,
    
    setIsSynthesizing: (isSpeaking) => set({ isSynthesizing: isSpeaking }),
    setIsRecognizing: (value) => set({ isRecognizing: value }),
  }))
);

export default useBlendShapeStore;
